/**
 * @file: useOrgMemberInfo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useServiceFactory } from '@euler/services/factory';
import { useAsyncResource } from '@euler/utils/hooks';
import { useCallback } from 'react';

export const useOrgMemberDetail = (memberId: number) => {
  const { storeService } = useServiceFactory();
  const fetch = useCallback(
    () => storeService.getMember(memberId),
    [storeService, memberId],
  );
  return useAsyncResource(fetch, `member/${memberId}/detail`, undefined);
};
